import type { MouseEventHandler, ReactNode } from 'react';

import { Box } from '@/shared/ui';

import WidgetButton from '@/shared/ui/primitives/WidgetButton';

type BaseWidgetButtonConfig = {
  id: string;
  visible: boolean;
  locked?: boolean;
};

type SimpleWidgetButtonConfig = BaseWidgetButtonConfig & {
  icon: ReactNode;
  title: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

type OverlayWidgetButtonConfig = BaseWidgetButtonConfig & {
  overlay: ReactNode;
};

export type WidgetButtonConfig = SimpleWidgetButtonConfig | OverlayWidgetButtonConfig;

type WidgetButtonsProps = {
  buttons: WidgetButtonConfig[];
  onLockedClick?: () => void;
};

const ModeLockedWrapper = ({
  children,
  locked,
  onLockedClick
}: {
  children: ReactNode;
  locked: boolean;
  onLockedClick: () => void;
}) => (
  <Box
    sx={{
      display: 'inline-flex',
      ...(locked && { opacity: 0.4, cursor: 'not-allowed', '& *': { pointerEvents: 'none' } })
    }}
    onClick={locked ? onLockedClick : undefined}
  >
    {children}
  </Box>
);

const noop = () => {};

const WidgetButtons = ({ buttons, onLockedClick }: WidgetButtonsProps) => (
  <Box sx={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
    {buttons
      .filter(b => b.visible)
      .map(button => (
        <ModeLockedWrapper
          key={button.id}
          locked={!!button.locked}
          onLockedClick={onLockedClick ?? noop}
        >
          {'overlay' in button ? (
            button.overlay
          ) : (
            <WidgetButton
              icon={button.icon}
              id={button.id}
              title={button.title}
              onClick={button.onClick}
            />
          )}
        </ModeLockedWrapper>
      ))}
  </Box>
);

export default WidgetButtons;
